import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { Footer } from "../components/Footer";
import { Form } from "../components/DataForm";
import Navigator from "../components/Navigator";
import Typography from '@mui/material/Typography'
import { Grid, GlobalStyles } from "@mui/material";
import { useContext, useEffect } from "react";
import { AppContext } from "../context";
import { useLocation } from "react-router-dom";
import React from "react";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}


export default function Home() {
  const {plan, getThemeAndPlans, logo, updateEvent} =  useContext<any>(AppContext);
  // const id = useParams();
  let query = useQuery();
  const id = query.get("id")
  
  useEffect(() => {
    console.log(id)
    getThemeAndPlans(id)
    
  },[])
  return (
    <>
     <GlobalStyles
            styles={[
              {
                ul: {
                  margin: 0,
                  padding: 0,
                  listStyle: "none",
                },
              },
            ]}
          />
      <Container component="main" maxWidth="lg">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        > 
         <Navigator step={0} />
         <Box sx={{ alignItems: 'center'}}>
         <Grid container direction='row' columnSpacing={1} sm={120} sx={{
          borderRadius: '10px', width: '100%', marginTop: '20px', alignContent: 'center'}}>
           <Box >
           <img src={logo} alt=""  style={{margin: '10px 0 0'}}/>
           </Box>
         </Grid>
         </Box>
          <Typography sx={{color: 'primary.main'}}variant='h4'>
            Falta Pouco!
          </Typography>
          <Typography
           sx={{color: '#656565', marginTop: '2vh'}}
           variant='subtitle1'
           align='center'>
          Precisamos de mais algumas informações <br />
          para a emissão de sua apólice.
          </Typography>
          <Typography
           sx={{color: '#656565', marginTop: '2vh'}}
           variant='subtitle1'
           align='center'>
          Plano selecionado:
          </Typography>
          <Typography
           sx={{color: 'primary.main'}}
           variant='subtitle1'
           align='center'>
          <strong>{plan.plan_selected}: R$ {plan.price}</strong>
          </Typography>
          <Form />
        </Box>
        <Box sx={{width:'100wv',
                  alignItems: "center"}}>
        <Footer />
        </Box>
      </Container>
      </>
  );
}
